import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import { FORM_FIELDS_MAP } from 'features/new-candidate/constants';
import { useGlobalStyles } from 'GlobalStyles';
import strings from 'strings';
import { FPActionButton, When } from 'UI/components/atoms';
import { FPCard, FPCardContent } from 'UI/components/atoms/FPCard';
import { SvgContentPaperEdit } from 'UI/res';

export const DataSheetSection = ({ disabled, dataSheetId, onClick }) => {
  const globalClasses = useGlobalStyles();

  const { errors } = useFormContext();

  const theme = useTheme();

  return (
    <FPCard className={globalClasses.newItemsSection}>
      <FPCardContent
        headerProps={{
          title: strings.candidates.create.candidateDataSheet.new.title,
          subheader: strings.candidates.create.candidateDataSheet.new.subtitle,
          variant: 'section'
        }}
        variant="relaxed"
      >
        <Box
          name={FORM_FIELDS_MAP.DataSheet.key}
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          gridGap={8}
        >
          <FPActionButton
            disabled={disabled}
            iconProps={{ fill: disabled ? theme.palette.grey[500] : theme.palette.grey[50] }}
            icon={SvgContentPaperEdit}
            onClick={onClick}
            text={dataSheetId ? 'Edit' : 'Fill In'}
          />
          <When condition={!!errors?.[FORM_FIELDS_MAP.DataSheet.key]}>
            <FormControl component="fieldset" error={!!errors?.[FORM_FIELDS_MAP.DataSheet.key]}>
              <FormHelperText>{errors?.[FORM_FIELDS_MAP.DataSheet.key]?.message}</FormHelperText>
            </FormControl>
          </When>
        </Box>
      </FPCardContent>
    </FPCard>
  );
};
